module.exports = __webpack_public_path__ + "static/media/Banner_LearningMaterial.6e3b20d4.jpg";